import { Result } from "@cartographerio/fp";
import { isFeatureF, isPoint } from "@cartographerio/geometry";
import { hasKey, hasOptionalKey, isNullable, isObject, isString, } from "@cartographerio/guard";
import { isAttachmentFolder, isTimestamp, } from "@cartographerio/types";
function isSiteAttributes(attrs) {
    return (isObject(attrs) &&
        hasOptionalKey(attrs, "name", isNullable(isString)) &&
        hasOptionalKey(attrs, "description", isNullable(isString)));
}
function isObservations(observations) {
    return (isObject(observations) &&
        hasOptionalKey(observations, "recorded", isNullable(isTimestamp)) &&
        hasKey(observations, "photographs", isAttachmentFolder));
}
export function isPartialData(data) {
    return (isObject(data) &&
        hasKey(data, "observations", isObservations) &&
        hasOptionalKey(data, "site", isNullable(isFeatureF(isPoint, isSiteAttributes))));
}
const g = Result.guard(isPartialData, "PartialData");
export function dataDescription(data) {
    return g(data).map((data) => `${data.site?.properties.name}, ${data.site?.properties.description}`);
}
export function dataTimestamp(data) {
    return g(data).map((data) => data.observations.recorded ?? null);
}
export function dataGeometry(data) {
    return g(data).map((data) => data.site?.geometry ?? null);
}
export function copyData(data) {
    return g(data).map(data => ({
        ...data,
        observations: {
            photographs: data.observations.photographs,
        },
    }));
}
//# sourceMappingURL=parts.js.map